import { render } from "./AnsweredCallsChart.vue?vue&type=template&id=6a4fd226&ts=true"
import script from "./AnsweredCallsChart.vue?vue&type=script&lang=ts"
export * from "./AnsweredCallsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__